import ParameterValue from './ParameterValue';

export default class MemberHonor {

    constructor() {
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let memberHonor = new MemberHonor();
        memberHonor.id = data.id;
        memberHonor.on = data.on;

        memberHonor.parameterValue = ParameterValue.fromData(data.parameterValue.data);

        return memberHonor;
    }

    isEmpty() {
        return !this.on && !this.parameterValue;
    }

    isValid() {
        if (!this.parameterValue) {
            return false;
        }
        if (!this.on) {
            return false;
        }

        return true;
    }

    serialize() {
        return {
            onDate: this.on,
            honorId: this.parameterValue.id,
        };
    }
}
